"use client";

import type { JSX } from "react";
import { useContext, useEffect } from "react";
import debugContext from "./contexts/debug";

declare global {
  interface Window {
    debugContent?: boolean;
  }
}

// Adds support for debug key (` / ~)
function DebugKey({ children }: { children: JSX.Element }) {
  const { debugMode, setDebugMode } = useContext(debugContext);

  // Add debug key support
  useEffect(() => {
    function handleDebugKey(e: KeyboardEvent) {
      if ((e.key == "`" || e.key == "~") && e.target == document.body) {
        const newDebugMode = !debugMode;
        setDebugMode(newDebugMode);
        window.debugContent = newDebugMode;
      }
    }

    document.addEventListener("keydown", handleDebugKey);
    return () => document.removeEventListener("keydown", handleDebugKey);
  }, [debugMode, setDebugMode]);

  return children;
}

export default DebugKey;
